import {useSelector} from "react-redux";
import {createModal} from "../../utils/modal";
import allergenIcon from "../../assets/img/allergen_icon.png";
import React from "react";
import ReactCountryFlag from "react-country-flag";

const HeaderButton = () => {
    const {locale} = useSelector(state => state.app)

    return (
        <div>
            <div onClick={() => createModal('language')} className={'w-[55px] h-[55px] rounded-[55px] border-[7px] border-white image-bg-thirdy flex justify-center items-center shadow-md fixed z-20 right-[10px] top-[10px]'}>
                <ReactCountryFlag
                    countryCode={ locale === 'en' ? 'US' : locale === 'ar' ? 'SA' : locale.toUpperCase()}
                    style={{
                        fontSize: '1.7em',
                    }}
                />
            </div>
            <div onClick={() => createModal('allergen_list')} className={'hidden w-[55px] h-[55px] rounded-[55px] border-[7px] border-white image-bg-thirdy flex justify-center items-center shadow-md fixed z-20 right-[75px] top-[10px]'}>
                <img src={allergenIcon} alt="" className={'w-[30px] h-[30px]'}/>
            </div>
        </div>
    )
}

export default HeaderButton;
